import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_page_auth = _resolveComponent("my-page-auth")!
  const _component_my_page_non = _resolveComponent("my-page-non")!

  return (_ctx.user !== null)
    ? (_openBlock(), _createBlock(_component_my_page_auth, { key: 0 }))
    : (_openBlock(), _createBlock(_component_my_page_non, { key: 1 }))
}